{
  "es": {
    "milestone": {
      "actions": {
        "activate": "Activar",
        "activate_phase": "Activar esta fase",
        "complete_phase": "Finalizar esta fase",
        "create": "Crear fase",
        "delete": "Eliminar",
        "delete_milestones": "Eliminar fase | Eliminar {count} fases",
        "move_down": "Bajar la fase",
        "move_unit_back": "Devolver la unidad aquí",
        "move_up": "Subir la fase",
        "new": "Fase",
        "reactivate_phase": "Reactivar esta fase"
      },
      "activate": {
        "body": "Todos los elementos de esta fase se publican para esta unidad y las personas asignadas reciben una notificación.",
        "body_empty": "No hace visible nada para el cliente.",
        "body_intermediate": "Las fases intermedias también se completan y todos los elementos vinculados a ellas también se publican.",
        "body_project": "Todos los elementos de esta fase se publican para este proyecto y las personas asignadas reciben una notificación.",
        "body_reactivate": "Esta fase vuelve a ser la fase actual. No se retira nada: todo lo que ya se publicó o se envió se mantiene. Las fases posteriores vuelven a estar planificadas.",
        "confirm": "Activar",
        "confirm_publish": "Activar y enviar",
        "confirm_reactivate": "Reactivar",
        "past_warning": "Volver a una fase anterior no deshará lo que ya ha ocurrido. Nada de lo compartido con los clientes se revocará automáticamente.",
        "title": "Activar fase",
        "title_activate": "¿Activar “{name}”?",
        "title_reactivate": "¿Reactivar “{name}”?",
        "verb_default": "Iniciar",
        "verb_share": "Compartir"
      },
      "assign": {
        "body": "Las unidades que selecciones pasan a «{to}». Los elementos de «{to}» y de cada fase que se salten se hacen visibles para el cliente y los asignados reciben una notificación.",
        "body_phases_only": "Las unidades que selecciones pasan a «{to}». El cliente ve la nueva fase.",
        "excluded": "No puedes seleccionar unidades que ya están en «{to}» o más allá."
      },
      "attach": {
        "add": "Añadir",
        "add_and_move": "Añadir y mover",
        "assigned_tag": "Asignado",
        "back": "Atrás",
        "counts": "{available} disponibles · {assigned} ya asignados",
        "description_decision": "Decisiones que el cliente debe tomar",
        "description_survey": "Encuestas para recopilar opiniones",
        "description_todo": "Tareas que el cliente debe completar",
        "elsewhere_tag": "Ahora en {name}",
        "empty": "No hay elementos disponibles",
        "empty_state_description": "Según tu plan, puedes añadir {kinds} a esta fase.",
        "intro": "Elige qué tipo de elemento quieres vincular a esta fase.",
        "move_notice_body": "Lo que ya se ha enviado sigue enviado. La fase anterior pierde este elemento.",
        "move_notice_item": "{element}, ahora en {phase}",
        "move_notice_title": "Este elemento se mueve a «{name}» | Estos elementos se mueven a «{name}»",
        "next": "Siguiente",
        "search": "Buscar",
        "select_intro": "Selecciona {kind} que quieras añadir.",
        "subtitle": "A la fase: {name}",
        "success": "Elementos añadidos",
        "title": "Añadir elementos"
      },
      "complete_phase": {
        "body": "Esta unidad finaliza esta fase y se queda sin fase activa. | {count} unidades finalizan esta fase y se quedan sin fase activa.",
        "body_sup": "Este proyecto finaliza esta fase y se queda sin fase activa.",
        "confirm": "Finalizar fase",
        "keep": "Mantener la fase activa",
        "title": "¿Finalizar “{name}”?"
      },
      "delete_phase": {
        "body": "Las unidades que están en esta fase se quedan sin fase activa. No pasan al paso anterior ni al siguiente. Los elementos de esta fase se desvinculan, no se eliminan. Los elementos ya publicados en una unidad siguen publicados: esos los eliminas en la unidad misma.",
        "body_last": "Las unidades que están en esta fase se quedan sin fase activa. Como es la última fase, pasan a contar como finalizadas. Los elementos de esta fase se desvinculan, no se eliminan. Los elementos ya publicados en una unidad siguen publicados: esos los eliminas en la unidad misma.",
        "body_sup": "Este proyecto se queda sin fase activa. No pasa al paso anterior ni al siguiente. Los elementos de esta fase se desvinculan, no se eliminan. Los elementos ya publicados siguen publicados: esos los eliminas en el proyecto mismo.",
        "confirm": "Eliminar fase",
        "keep": "Conservar fase",
        "title": "¿Eliminar «{name}»?"
      },
      "detach": {
        "body": "Esto quita el elemento de esta fase. El elemento en sí sigue existiendo y las unidades que ya lo vieron lo conservan. Las unidades nuevas ya no lo reciben en esta fase.",
        "confirm": "Desvincular",
        "keep": "Conservar",
        "title": "¿Desvincular «{name}»?"
      },
      "filters": {
        "clear": "Borrar todos los filtros",
        "done": "Listo",
        "group_milestones": "Fases",
        "group_status": "Estado",
        "group_title": "Contenido de la fase",
        "no_phase": "Sin fase",
        "no_units_here": "Ninguna unidad aquí",
        "nothing_assigned": "Nada asignado",
        "phase_last": "En la última fase",
        "since_month_over": "Más de un mes",
        "since_quarter_over": "Más de 3 meses",
        "since_two_weeks_over": "Más de 2 semanas",
        "title": "Filtros",
        "units_here": "Tiene unidades aquí"
      },
      "labels": {
        "add_element": "Añadir elemento",
        "assign_units": "Asignar unidades",
        "assigned_count": "0 asignados | 1 asignado | {count} asignados",
        "assigned_elements": "Elementos asignados",
        "assigned_empty_description": "Vincula {kinds} a esta fase",
        "assigned_empty_title": "Todavía no hay elementos",
        "bulk_assign_title": "Selecciona las unidades a las que quieres asignar la fase «{milestone_name}»",
        "complete_units": "Finalizar {count} unidad | Finalizar {count} unidades",
        "completed_subtitle": "Estas unidades han recorrido el flujo de trabajo",
        "completed_title": "Finalizado",
        "detach": "Desvincular",
        "detach_element": "Desvincular {name}",
        "drag_to_reorder": "Arrastra para reordenar",
        "edit_milestone": "Editar fase",
        "element_count": "{count} elemento | {count} elementos",
        "elements_assign_link": "Asignar elementos en Workflows",
        "elements_attached": "Elementos vinculados: {elements}",
        "elements_empty": "Todavía no hay elementos vinculados a esta fase.",
        "kind_decision": "Decisión | Decisiones",
        "kind_decision_count": "{count} decisión | {count} decisiones",
        "kind_survey": "Encuesta | Encuestas",
        "kind_survey_count": "{count} encuesta | {count} encuestas",
        "kind_todo": "Tarea | Tareas",
        "kind_todo_count": "{count} tarea | {count} tareas",
        "locked_not_sent": "{count} elemento está bloqueado por tu plan y no se enviará. | {count} elementos están bloqueados por tu plan y no se enviarán.",
        "locked_tooltip": "No incluido en tu plan actual. No se enviará a los clientes.",
        "milestone": "Fase",
        "milestone_current": "Fase actual",
        "milestone_name": "Nombre de la fase",
        "move_units_to": "Mover {count} unidad a {name} | Mover {count} unidades a {name}",
        "new_milestone": "Nueva fase",
        "no_results": "No se han encontrado fases",
        "please_select": "Selecciona una nueva fase",
        "position": "Posición",
        "progress": "Progreso",
        "publishes_empty": "Nada vinculado todavía",
        "reorder_filtered": "Borra la búsqueda o el filtro para reordenar las fases",
        "search_empty_state": "Todavía no se han creado fases. Haz clic aquí para empezar",
        "search_phase": "Buscar fase",
        "search_unit": "Buscar unidad",
        "search_units": "Buscar unidades",
        "since": "Desde",
        "started_on": "Iniciada el {date}",
        "status_active": "En curso",
        "status_completed": "Completada",
        "status_planned": "Planificada",
        "unit_active_since": "En curso desde el {date}",
        "unit_completed_on": "Completado el {date}",
        "unit_timeline_empty": "Todavía no se han creado fases para este proyecto.",
        "units": "Unidades",
        "units_completed": "Ninguna unidad finalizada | 1 unidad finalizada | {count} unidades finalizadas",
        "units_empty": "Todavía ninguna unidad ha llegado a esta fase.",
        "units_here": "Ninguna unidad aquí | 1 unidad aquí | {count} unidades aquí",
        "units_no_results": "No se han encontrado unidades",
        "unstarted_subtitle": "Estas unidades no tienen una fase activa",
        "unstarted_title": "Sin fase",
        "view_phases": "Fases",
        "view_units": "Unidades",
        "warning_delete": "Si eliminas una fase que está asignada a una unidad, el cliente dejará de ver en qué fase se encuentra su unidad. ¡Asegúrate de asignar una nueva fase a esas unidades!"
      },
      "move": {
        "body": "Esta unidad pasa de «{from}» a «{to}». Los elementos de «{to}» se hacen visibles para el cliente y los asignados reciben una notificación. | Estas unidades pasan de «{from}» a «{to}». Los elementos de «{to}» se hacen visibles para el cliente y los asignados reciben una notificación.",
        "body_phases_only": "Esta unidad pasa de «{from}» a «{to}». El cliente ve la nueva fase. | Estas unidades pasan de «{from}» a «{to}». El cliente ve la nueva fase.",
        "confirm": "Mover y notificar",
        "confirm_phases_only": "Mover",
        "elements": "Hace visible {elements} para el cliente",
        "title": "¿Mover {count} unidad a «{name}»? | ¿Mover {count} unidades a «{name}»?"
      },
      "overview": {
        "no_phase": "Sin fase",
        "not_started": "No iniciado",
        "since_date": "Desde {date}",
        "step_of": "Paso {step} de {total}"
      },
      "publication_failed": {
        "body": "El envío de los elementos de esta fase ha fallado para 1 unidad. | El envío de los elementos de esta fase ha fallado para {count} unidades.",
        "retried": "Los elementos se están enviando de nuevo",
        "retry": "Volver a enviar"
      },
      "reorder": {
        "body_earlier": "Adelantar esta fase no retira nada de lo que ya se ha publicado. Las unidades conservan lo que tienen; solo cambia el orden.",
        "body_earlier_sup": "Adelantar esta fase no retira nada de lo que ya se ha publicado. El proyecto conserva lo que tiene; solo cambia el orden.",
        "body_later": "Retrasar esta fase no retira nada de lo que ya se ha publicado. Las unidades conservan lo que tienen; solo cambia el orden.",
        "body_later_sup": "Retrasar esta fase no retira nada de lo que ya se ha publicado. El proyecto conserva lo que tiene; solo cambia el orden.",
        "body_passed": "Las unidades en una fase posterior pasan ahora por esta fase. Todo lo vinculado a ella se les publica de inmediato.",
        "body_passed_sup": "Este proyecto pasa ahora por esta fase. Todo lo vinculado a ella se publica de inmediato.",
        "body_passes": "Las unidades en esta fase pasan ahora por las fases intermedias. Todo lo vinculado a esas fases se les publica de inmediato.",
        "body_passes_sup": "Este proyecto pasa ahora por las fases intermedias. Todo lo vinculado a esas fases se publica de inmediato.",
        "confirm": "Mover fase",
        "count": "{count} unidad pasa por {phases} de una vez | {count} unidades pasan por {phases} de una vez",
        "count_sup": "Este proyecto pasa por {phases} de una vez",
        "crossed": "{name} ({elements})",
        "nothing": "nada",
        "phases": "{count} fase | {count} fases",
        "title": "¿Colocar «{name}» después de «{previous}»?",
        "title_first": "¿Colocar «{name}» en primer lugar?"
      },
      "toasts": {
        "bulk_assigned": "La fase se ha asignado correctamente a las unidades seleccionadas",
        "create_success": "Fase creada correctamente",
        "deleted": "Fase eliminada",
        "phase_without_units": "Ya no hay unidades en esta fase",
        "sup_assigned": "La fase se ha activado correctamente",
        "sup_completed": "Fase finalizada",
        "units_completed": "{count} unidad finalizada | {count} unidades finalizadas",
        "units_moved": "{count} unidad movida | {count} unidades movidas",
        "update_success": "Las fases se han actualizado correctamente"
      },
      "validation": {
        "needNamePrimary": "Se requiere el nombre en el idioma principal ({language})"
      }
    }
  }
}
